import React from "react";
// material ui
import TabPanelWrapper from "./TabPanelWrapper";
import { Card, CardContent } from "@mui/material";


const TabPanelLayout = ({ background, children, value, tabsData, padding, ...other }) => {
  const backgroundPadding = background ?? true;
  return (
    <>
      {tabsData?.length > 0 &&
        tabsData?.map((tab, index) => (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            key={index}
            {...other}
            style={{
              height: "100%",
              paddingTop: "0rem!important",
              // padding: "0.5rem!important",
              paddingBottom: padding ? "0.5rem" : "0px",
            }}
          >
       
            {/* This is for the card background for the entire tab pages, no need to pass the card from each component */}
            {/* <CommonCardBackgroundPage
              // This props for the giving the padding for the card
              background={backgroundPadding}
            > */}

            {value === index && (
              <TabPanelWrapper components={tab?.components} />
            )}
            {/* </CommonCardBackgroundPage> */}
            {/* :
              value === index && (
                <TabPanelWrapper components={tab?.components} />
              )} */}
          </div>
        ))}
    </>
  );
};

export default TabPanelLayout;
